import React from "react";
import Popup from "./Popup";
import CaloriesForm from "./CaloriesForm";

export default function Basics() {
	return (
		<>
		<u><h2>Basics of Fat Loss</h2></u>
		<section className="subHeader">
		 <p>
			 Most of us want to lose that extra body fat, reason to do that could be either due to health problems or we just want to get in shape. Fat gets stored in different parts of our body, the amount of fat stored in a specific part of our body depends upon our genes, hormones, age, lifestyle etc.
			How to know if you are overweight... BMI/BFP?
			</p>
			
			<p>
			There are lot of suggestions people give us when it comes to losing body fat e.g 
			<ul className="task-list">
				<li>Don't eat Fats/Carbs</li>
				<li>Don't eat Sugar/Rice</li>
				<li>Don't eat in the evening/night</li>
			</ul>
			The list of "what not to do" goes on and on. Rather than focusing on "what not to do" we will focus on "what to do" exactly.  So let's dive right in!! 
			</p>
		
			
		
			<blockquote>
			<p>
				<strong><u>Calories:</u></strong> Our body needs energy to do various activities and support itself, we get that energy from the food we eat. So, we use calories as a unit to measure the amount of energy we get from each food item. Different types of food have different amounts of calories depending upon its constituents.  
			</p>
			</blockquote>
			
			<p>
				<strong>The only thing that one need to lose body weight is to stay <u>Calorie Deficit</u> i.e at the end of day you need to make sure that total calories residing in your body should be less than your  <u>Maintenance Calories</u>.</strong> All types of diets (Keto,Intermittent etc.) for weight loss work on the principal of calorie deficiency only. It's important to note that when we say lose weight we mean to lose extra fat mass, no one wants to lose muscle mass. No one. Not men, Not women.  
			</p>
			
			<blockquote>
			<p>
				<strong><u>Maintenance Calories:</u></strong> Amount of calories that one should consume on a daily basis to maintain our current weight. The first step towards setting your diet for reaching your goal physique, is to get an estimate of your maintenance calories. 
				<ul className="task-list">
					<li>We will lose weight if we are eating less than maintenance calories because our body will get lesser energy than required to maintain current weight</li>
					<li>We will gain weight if we are eating more than our maintenance calories because extra energy will be stored as fat or muscles depending upon if you are working out and taking required macros or not.  </li>
				</ul>
			</p>
			</blockquote>
			
			
			<h4>Now the question is how to know your maintenance calories ?</h4> 
			<p>There are a lot of methods out there to find maintenance calories and different methods have different outputs. Lets use one famous method to calculate maintenance calories approximately. This will give you a number to start with. 
				<Popup content={{heading:"",component: CaloriesForm}}/>
			</p>
			
			<blockquote>
			<p>
				As we know maintenance calories depend on various factors such as person’s height, weight, gender, body composition, and activity level per day so we can only go for estimates only not exact value. The best way to estimate your actual maintenance calories is "Observe & Adjust" over a few weeks. Assuming from the formulae above your maintenance calories are "M", now try to consume "M" calories per day and be consistent for two weeks, you might be off here & there. Every morning, after you have used the washroom, before eating or drinking anything, empty your stomach note down your weight and take an average at the end of each week.
				You will notice difference in weight averages of each week:
			</p>
				<ul className="task-list">
					<li>if your lost weight that means you were eating less than your "actual maintenance calories".</li>
					<li>if you have gained weight that means you ate more than your "actual maintenance calories".</li>
					<li>and if you stay same weight you ate around your maintenance calories.</li>
				</ul>		
			
			</blockquote>
			
			<h4>Now the next question is how much calories deficit you should be ?</h4> 
			<p><strong>To lose "n" Kg of weight per month just be approximately (n*250) calories deficit per day.</strong> (Including diet and workout if any).  A calorie deficit of ~20% has been shown to be a safe deficit and leads to a reasonably good rate of fat loss. 20% is a large enough calorie deficit to maximize fat loss but low enough to minimize muscle loss.						
			</p>
			
			<p>
			Going too low on your calories will surely increase the rate of weight loss, but that comes at the cost of losing your precious muscle mass and can result in the opposite effect in the near future by reducing metabolism. It is advised not to lose more than 4kgs per month and make sure you are eating at least 1200 calories per day as it is the minimum prescribed by nutritionists.. 
			</p>
			
			<p><strong>Important: </strong>
			What you want is to get lean, toned, and defined, not skinny, flabby, and weak. So along with calorie deficiency we have to make sure we maintain our muscle mass. To do that we have to make sure we eat an adequate amount of protein and workout in the gym 3-4 days each week, whatever suits your lifestyle the best. Resistance training is what will keep your muscles from being eaten away by energy deficit.The harder you work, the more calories you'll burn overall (<em>we will talk more about diet and exercise for fat loss in sections below</em>) 
			</p>
			
			
			<p>Summary of this section:</p>
			<ol className="task-list">
				<li>Estimate Your maintenance calories.</li>
				<li>Fix weight you want to lose per month and set your calorie deficit accordingly using "n*250" calorie deficit per day for losing "n" Kgs per month. </li>
				<li>Be consistent with your diet and workouts.</li>
				<li>As you lose weight your maintenance calories will reduce so adjust accordingly in a few weeks. </li>
			</ol>
		</section>
		</>
	);
}